import { LuPlay, LuPause } from "react-icons/lu";
import { MdReplay5, MdForward5, MdSkipPrevious, MdSkipNext, MdFullscreen, MdVolumeUp, MdVolumeOff, MdSpeed } from "react-icons/md";
import ProgressBar from "./ProgressBar";
import {Grid, Typography} from "@mui/joy";
import React from "react";

const PlayerControls = ({ isPlaying, isMuted, onPlayPause,
                            onFullscreen,
                            progress, progressSecLabel, durationSecLabel,
                            onSeekStart, onSeeking, onSeekEnd,
                            onNext, onPrevious,
                            onRewind, onForward}) => {
    return (

        <div style={{
            width: "100%",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            backgroundColor: "rgba(0,0,0,0.2)", // Semi-transparent black
        }}>

            {/* Progress Bar */}
            <ProgressBar
                value={progress}
                onSeekStart={onSeekStart}
                onSeeking={onSeeking}
                onSeekEnd={onSeekEnd}
            />

            <Grid container
                  spacing={2}
                  sx={{ width: "100%", alignItems: "center" }}>
                <Grid xs={4} sx={{ display: "flex", justifyContent: "left", padding: "10px 20px" }}>
                    <button
                        // onClick={onMuteToggle}
                        style={{
                            background: "transparent",
                            border: "none",
                            cursor: "pointer",
                            fontSize: "24px",
                            color: "rgba(255, 255, 255, 0.5)",
                        }}
                    >
                        {isMuted ? <MdVolumeOff /> : <MdVolumeUp />}
                    </button>

                    <Typography
                        sx={{
                            padding: "10px",
                            color: "#f5f5f5", // Almost white
                            textShadow: "1px 1px 3px rgba(0, 0, 0, 0.8)",
                        }}
                    >
                        {progressSecLabel} / {durationSecLabel}
                    </Typography>

                </Grid>
                <Grid xs={4} sx={{ display: "flex", justifyContent: "center" }}>

                    <button
                        onClick={onPrevious}
                        style={{
                            background: "transparent",
                            border: "none",
                            cursor: "pointer",
                            fontSize: "28px",
                            color: "rgba(255, 255, 255, 0.9)",
                        }}
                    >
                        <MdSkipPrevious />
                    </button>

                    <button
                        onClick={onRewind}
                        style={{
                            background: "transparent",
                            border: "none",
                            cursor: "pointer",
                            fontSize: "24px",
                            color: "rgba(255, 255, 255, 0.9)",
                        }}
                    >
                        <MdReplay5 />
                    </button>

                    <button
                        onClick={onPlayPause}
                        style={{
                            background: "transparent",
                            border: "none",
                            cursor: "pointer",
                            fontSize: "24px",
                            color: "rgba(255, 255, 255, 0.9)",
                        }}
                    >
                        {isPlaying ? <LuPause /> : <LuPlay />}
                    </button>

                    <button
                        onClick={onForward}
                        style={{
                            background: "transparent",
                            border: "none",
                            cursor: "pointer",
                            fontSize: "24px",
                            color: "rgba(255, 255, 255, 0.9)",
                        }}
                    >
                        <MdForward5 />
                    </button>

                    <button
                        onClick={onNext}
                        style={{
                            background: "transparent",
                            border: "none",
                            cursor: "pointer",
                            fontSize: "24px",
                            color: "rgba(255, 255, 255, 0.9)",
                        }}
                    >
                        <MdSkipNext />
                    </button>

                </Grid>
                <Grid xs={4} sx={{ display: "flex", justifyContent: "flex-end", padding: "10px 20px" }}>


                    <button
                        // onClick={onSpeedChange}
                        style={{
                            background: "transparent",
                            border: "none",
                            cursor: "pointer",
                            fontSize: "24px",
                            color: "rgba(255, 255, 255, 0.5)",
                        }}
                    >
                        <MdSpeed />
                    </button>

                    <button
                        onClick={onFullscreen}
                        style={{
                            background: "transparent",
                            border: "none",
                            cursor: "pointer",
                            fontSize: "24px",
                            color: "rgba(255,255,255,0.9)",
                        }}
                    >
                        <MdFullscreen />
                    </button>
                </Grid>
            </Grid>

        </div>
    );
};

export default PlayerControls;
